import { upsertOfdOrderPrintStatus } from "../services";

const updateOfdStatus = async ({ sOrderID, newStatus, isAuto = false, reasonCode = null, printFlag = "Y", serverUrl = process.env.REACT_APP_serverUrl }) => {
  const statusMapping = {
    Acknowledged: "AK",
    Cancelled: "CC",
    "Food Ready": "FR",
    Dispatched: "DI",
  };
  const statusCode = statusMapping[newStatus] || newStatus;

  try {
    const data = {
      query: `mutation {
          upsertOfdOrderStatus(order: [{
            sOrderID: "${sOrderID}"
            ofdStatus: "${statusCode}"
            print: "${printFlag}"
          }]) { 
            status
            message   
          }
        }`,
    };
    const response = await upsertOfdOrderPrintStatus(data);

    const result = response?.data?.data?.upsertOfdOrderStatus;
    if (result?.status === "200") {
      return {
        success: true,
        message: result.message,
        statusCode,
      };
    } else {
      console.error("Status update failed:", result?.message);
      return {
        success: false,
        message: result?.message || "Failed to update order status",
      };
    }
  } catch (error) {
    console.error("Error updating order status:", error);
    return {
      success: false,
      message: "Error updating order status",
    };
  }
};

export default updateOfdStatus;
